// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Link__container-aeec8c {
  cursor: pointer;
  color: var(--color);
}

.Link__container-aeec8c:hover {
  color: var(--color-hover);
}

.Link__container-aeec8c:focus-visible {
  color: var(--color-focus);
}

.Link__container-aeec8c:active {
  color: var(--color-active);
}

.Link__container-aeec8c:disabled {
  color: var(--color-disabled);
}

.Link__container-aeec8c,
.Link__container-aeec8c:hover,
.Link__container-aeec8c:focus-visible {
  text-decoration: none;
}

.Link__container-aeec8c.Link__underline-c92c3f:hover,
.Link__container-aeec8c.Link__underline-c92c3f:focus-visible {
  text-decoration: underline;
}

.Link__container-aeec8c:disabled,
.Link__container-aeec8c.Link__underline-c92c3f:disabled {
  cursor: default;
  text-decoration: none;
}

.Link__secondary-color-e4ee6d {
  --color: var(--brand-secondary-40);
  --color-hover: var(--brand-secondary-40);
  --color-focus: var(--brand-secondary-40);
  --color-active: var(--brand-secondary-40);
  --color-disabled: var(--brand-secondary-20);
}

.Link__primary-color-c6d00a {
  --color: var(--brand-primary-40);
  --color-hover: var(--brand-primary-50);
  --color-focus: var(--brand-primary-50);
  --color-active: var(--brand-primary-60);
  --color-disabled: var(--brand-primary-20);
}

.Link__title-link-2-color-e4f7ef {
  --color: var(--base-110);
  --color-hover: var(--base-90);
  --color-focus: var(--base-90);
  --color-active: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Link/Link.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;;;EAGE,qBAAA;AACF;;AAEA;;EAEE,0BAAA;AACF;;AAEA;;EAEE,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,kCAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;AACF;;AAEA;EACE,gCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,yCAAA;AACF;;AAEA;EACE,wBAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;AACF","sourcesContent":[".container {\n  cursor: pointer;\n  color: var(--color);\n}\n\n.container:hover {\n  color: var(--color-hover);\n}\n\n.container:focus-visible {\n  color: var(--color-focus);\n}\n\n.container:active {\n  color: var(--color-active);\n}\n\n.container:disabled {\n  color: var(--color-disabled);\n}\n\n.container,\n.container:hover,\n.container:focus-visible {\n  text-decoration: none;\n}\n\n.container.underline:hover,\n.container.underline:focus-visible {\n  text-decoration: underline;\n}\n\n.container:disabled,\n.container.underline:disabled {\n  cursor: default;\n  text-decoration: none;\n}\n\n.secondary-color {\n  --color: var(--brand-secondary-40);\n  --color-hover: var(--brand-secondary-40);\n  --color-focus: var(--brand-secondary-40);\n  --color-active: var(--brand-secondary-40);\n  --color-disabled: var(--brand-secondary-20);\n}\n\n.primary-color {\n  --color: var(--brand-primary-40);\n  --color-hover: var(--brand-primary-50);\n  --color-focus: var(--brand-primary-50);\n  --color-active: var(--brand-primary-60);\n  --color-disabled: var(--brand-primary-20);\n}\n\n.title-link-2-color {\n  --color: var(--base-110);\n  --color-hover: var(--base-90);\n  --color-focus: var(--base-90);\n  --color-active: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Link__container-aeec8c`,
	"underline": `Link__underline-c92c3f`,
	"secondary-color": `Link__secondary-color-e4ee6d`,
	"secondaryColor": `Link__secondary-color-e4ee6d`,
	"primary-color": `Link__primary-color-c6d00a`,
	"primaryColor": `Link__primary-color-c6d00a`,
	"title-link-2-color": `Link__title-link-2-color-e4f7ef`,
	"titleLink2Color": `Link__title-link-2-color-e4f7ef`
};
module.exports = ___CSS_LOADER_EXPORT___;
